;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	var Model = APP.module('Model');

	View.User = View.User.extend({
		default_page : 'tipping'
	});

}(window, APP, Backbone, Marionette, $, _));
